/**
 * Appfactory Studio — entry point
 */

import { setCurrentUserId } from './checkpointHelper/auth/context';
import { view, registerViews } from './views';
import { initSettingsData } from './settings/state';
import { updateUserAccountNav } from './auth-display';
import * as bootstrap from 'bootstrap';

import { CHECKPOINT_APPS, ClientHandler, ClientUserType } from './checkpoint';
import { app, checkpoint } from './checkpointHelper/app';
import { BrainMember, CheckpointAuthUser } from './checkpointHelper/static/auth-types';
import { setCheckpointHandler } from './checkpointHelper/static/auth-session';

// appfactory3's ApplicationManager expects a legacy "App" DOM-helper global
// (App.call(selector).append(...)), normally supplied by the appfactory.studio
// SDK script. pdf_editor doesn't load that SDK, so alias it to jQuery — which
// is loaded via a plain <script> tag in the blade view — since jQuery's
// $(selector) supports the same .append() call appfactory3 makes.
// (window as any).App = { call: (window as any).jQuery ?? (window as any).$ };

(window as any).bootstrap = bootstrap;

const handler = new ClientHandler(checkpoint, '/');
setCheckpointHandler(handler);

const result = await handler.handlePageLoad();

if (!result.authState.isAuthenticated) {
    window.location.href = handler.buildLoginUrl('normal', CHECKPOINT_APPS.PDF_EDITOR);
    throw new Error('Coordinator requires an authenticated Checkpoint session');
}

const authUser = result.authState.user as CheckpointAuthUser | null;
const authMember = result.authState.member as BrainMember | null;

if (!authUser || !authMember) {
    await handler.logout();
    window.location.href = handler.buildLoginUrl('normal', CHECKPOINT_APPS.PDF_EDITOR);
    throw new Error('Checkpoint session is missing required user or member');
}

app.window.user = authUser;
app.window.member = authMember;
app.window.userType = result.authState.userType as ClientUserType;
setCurrentUserId(authUser.id);

await initSettingsData();

registerViews(app);
document.body.insertAdjacentHTML('beforeend', view.getHtml());








// const handler = new ClientHandler(checkpoint, '/'); 
// const result = await handler.handlePageLoad();

// if (!result.authState.isAuthenticated) {
//     window.location.href = handler.buildLoginUrl('normal');
// } else {
//     const user = result.authState.user;
//     if (user?.id != null) {
//         setCurrentUserId(user.id);
//     }

//     registerViews(app);
//     document.body.insertAdjacentHTML('beforeend', view.getHtml());
// }

// export { checkpoint };
